import { useState } from 'react';

interface Project {
  id: number;
  title: string;
  category: string;
  location: string;
  year: string;
  surface: string;
  budget: string;
  description: string;
  imageBefore: string;
  imageAfter: string;
  features: string[];
}

const projects: Project[] = [
  {
    id: 1,
    title: 'Villa Moderne Lubumbashi',
    category: 'Construction Neuve',
    location: 'Lubumbashi, RDC',
    year: '2025',
    surface: '350 m²',
    budget: '1.2M €',
    description: 'Construction d\'une villa contemporaine avec piscine intérieure, domotique complète et panneaux solaires. Architecture épurée avec grandes baies vitrées.',
    imageBefore: 'https://readdy.ai/api/search-image?query=empty%20construction%20land%20plot%20in%20Africa%20ready%20for%20building%2C%20flat%20terrain%20with%20markers%2C%20simple%20background%2C%20professional%20real%20estate%20photography%20in%20African%20setting%2C%20clear%20blue%20sky%2C%20tropical%20landscape&width=800&height=600&seq=project-1-before-africa&orientation=landscape',
    imageAfter: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/c6db8b5e4837d63ba80a1dd039bd0016.jpeg',
    features: ['Piscine intérieure', 'Domotique', 'Panneaux solaires', 'Home cinéma', 'Cave à vin']
  },
  {
    id: 2,
    title: 'Bâtiment Administratif R+2 - Église Temps de la Moisson',
    category: 'Construction Neuve',
    location: 'Lubumbashi, RDC',
    year: '2025',
    surface: '600 m²',
    budget: '800K €',
    description: 'Construction d\'un bâtiment administratif moderne R+2 pour l\'église Temps de la Moisson. Structure en béton armé avec finitions contemporaines et espaces fonctionnels.',
    imageBefore: 'https://readdy.ai/api/search-image?query=construction%20site%20foundation%20in%20progress%20in%20African%20city%2C%20concrete%20pillars%20and%20beams%20visible%2C%20building%20under%20construction%20at%20night%2C%20construction%20materials%20on%20site%2C%20tropical%20setting%20with%20palm%20trees&width=800&height=600&seq=project-2-before-church-admin&orientation=landscape',
    imageAfter: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/e4fd3e2b20f1aed98f73a7126f239b0e.jpeg',
    features: ['Structure R+2', 'Bureaux administratifs', 'Salles de réunion', 'Espaces fonctionnels', 'Finitions modernes']
  },
  {
    id: 3,
    title: 'Extension Verrière Likasi',
    category: 'Extension',
    location: 'Lubumbashi, RDC',
    year: '2025',
    surface: '80 m²',
    budget: '280K €',
    description: 'Extension contemporaine avec verrière d\'atelier, créant un espace de vie lumineux ouvert sur le jardin. Structure acier et verre.',
    imageBefore: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/bc22bd179606bfd827871e603a239d47.jpeg',
    imageAfter: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/bc22bd179606bfd827871e603a239d47.jpeg',
    features: ['Verrière atelier', 'Structure acier', 'Chauffage au sol', 'Baies coulissantes', 'Terrasse bois']
  },
  {
    id: 4,
    title: 'Rénovation Complexe Résidentiel',
    category: 'Rénovation',
    location: 'Lubumbashi, RDC',
    year: '2023',
    description: 'Modernisation complète d\'un complexe résidentiel avec amélioration des infrastructures et des espaces communs.',
    imageBefore: 'https://readdy.ai/api/search-image?query=Old%20residential%20complex%20building%20before%20renovation%20in%20Lubumbashi%20Democratic%20Republic%20of%20Congo%2C%20aged%20apartment%20buildings%20needing%20maintenance%2C%20weathered%20concrete%20structures%2C%20simple%20light%20background%2C%20professional%20architectural%20photography%20showing%20building%20exterior%20requiring%20modernization%20work&width=800&height=600&seq=project-4-before&orientation=landscape',
    imageAfter: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/cf5525f54f96e18b090612fced903793.jpeg',
    details: {
      client: 'Société Immobilière du Congo',
      duration: '10 mois',
      surface: '3500 m²',
      budget: 'Confidentiel'
    }
  },
  {
    id: 5,
    title: 'Loft Industriel Kasumbalesa',
    category: 'Transformation',
    location: 'Lubumbashi, RDC',
    year: '2025',
    surface: '220 m²',
    budget: '380K €',
    description: 'Transformation d\'un ancien atelier industriel en loft design. Conservation des éléments d\'origine (poutres, briques) avec aménagement contemporain.',
    imageBefore: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/9496f36e9066230763912f1927f66c8f.jpeg',
    imageAfter: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/9496f36e9066230763912f1927f66c8f.jpeg',
    features: ['Mezzanine', 'Briques apparentes', 'Poutres métalliques', 'Cuisine ouverte', 'Verrière intérieure']
  },
  {
    id: 6,
    title: 'Maison Passive Kabove',
    category: 'Construction Écologique',
    location: 'Lubumbashi, RDC',
    year: '2025',
    surface: '280 m²',
    budget: '850K €',
    description: 'Construction d\'une maison passive certifiée avec isolation renforcée, VMC double flux, récupération d\'eau de pluie et géothermie.',
    imageBefore: 'https://readdy.ai/api/search-image?query=empty%20residential%20land%20plot%20in%20Africa%20for%20eco%20construction%2C%20natural%20terrain%2C%20tropical%20trees%20in%20background%2C%20simple%20landscape%2C%20professional%20photography%20in%20African%20setting&width=800&height=600&seq=project-6-before-africa&orientation=landscape',
    imageAfter: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/fc1b8cb7924ac8f1e7accb5f0752ae90.jpeg',
    features: ['Certification Passive', 'Géothermie', 'VMC double flux', 'Récupération eau', 'Isolation renforcée']
  },
  {
    id: 7,
    title: "Extension Centre Commercial",
    category: "Construction",
    location: "Lubumbashi, RDC",
    year: "2023",
    description: "Extension moderne d'un centre commercial avec nouvelles boutiques et espaces de restauration.",
    imageAfter: "https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/8f8dfa3e524148258e50ccc3c1ad22ac.jpeg",
    imageBefore: "https://readdy.ai/api/search-image?query=Empty%20commercial%20space%20before%20renovation%20in%20Lubumbashi%20Democratic%20Republic%20of%20Congo%2C%20vacant%20retail%20area%20with%20concrete%20floors%20and%20basic%20structure%2C%20unfinished%20interior%20space%2C%20natural%20lighting%20through%20windows%2C%20simple%20architectural%20framework%20ready%20for%20commercial%20development&width=800&height=600&seq=project-7-before&orientation=landscape"
  },
  {
    id: 8,
    title: "Rénovation Immeuble de Bureaux",
    category: "Rénovation",
    location: "Lubumbashi, RDC",
    year: "2024",
    imageBefore: "https://readdy.ai/api/search-image?query=old%20deteriorated%20office%20building%20exterior%20concrete%20facade%20needing%20renovation%20simple%20background%20daytime%20architectural%20photography%20wide%20angle%20view%20showing%20full%20structure%20urban%20setting%20professional%20real%20estate%20style&width=800&height=600&seq=gallery-before-8&orientation=landscape",
    imageAfter: "https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/a965864b13f1809b6f15fb62f02d00c4.jpeg",
    description: "Transformation complète d'un immeuble de bureaux avec modernisation des façades, rénovation intérieure et mise aux normes énergétiques."
  },
  {
    id: 9,
    title: 'Duplex Penthouse Likasi',
    category: 'Rénovation Luxe',
    location: 'Lubumbashi, RDC',
    year: '2025',
    surface: '240 m²',
    budget: '680K €',
    description: 'Rénovation complète d\'un duplex avec création d\'une terrasse panoramique, escalier design et domotique intégrée.',
    imageBefore: 'https://readdy.ai/api/search-image?query=old%20duplex%20apartment%20interior%20in%20African%20city%20before%20luxury%20renovation%2C%20dated%20decor%2C%20needs%20complete%20transformation%2C%20simple%20background%2C%20real%20estate%20photography%20in%20Africa&width=800&height=600&seq=project-9-before-africa&orientation=landscape',
    imageAfter: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/5aab1144d3427eaf68769d9d7c7ba212.jpeg',
    features: ['Terrasse 60m²', 'Escalier design', 'Domotique', 'Cuisine Boffi', 'Salles de bains luxe']
  }
];

const categories = ['Tous', 'Construction Neuve', 'Rénovation Complète', 'Extension', 'Aménagement Commercial', 'Transformation', 'Construction Écologique', 'Commerce', 'Aménagement Extérieur', 'Rénovation Luxe'];

const ProjectsGrid = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tous');
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const [showBefore, setShowBefore] = useState(true);

  const filteredProjects = selectedCategory === 'Tous' 
    ? projects 
    : projects.filter(p => p.category === selectedCategory);

  return (
    <section className="py-12 sm:py-16 lg:py-20 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Filtres */}
        <div className="mb-10 sm:mb-12 flex flex-wrap gap-2 sm:gap-3 justify-center">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              className={`px-3 sm:px-4 md:px-6 py-2 sm:py-2.5 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer text-xs sm:text-sm md:text-base ${
                selectedCategory === cat
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Grille de projets */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              onClick={() => setSelectedProject(project)}
              className="group cursor-pointer bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative h-48 sm:h-56 md:h-64 overflow-hidden">
                <img
                  src={project.imageAfter}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3 sm:top-4 sm:right-4 bg-blue-600 text-white px-3 py-1 sm:px-4 sm:py-1.5 rounded-full text-xs sm:text-sm font-medium">
                  {project.year}
                </div>
              </div>
              <div className="p-4 sm:p-6">
                <div className="text-xs sm:text-sm text-blue-600 font-semibold mb-2">{project.category}</div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">{project.title}</h3>
                <div className="flex items-center text-gray-600 text-xs sm:text-sm mb-3">
                  <i className="ri-map-pin-line mr-2"></i>
                  {project.location}
                </div>
                <div className="flex items-center justify-between text-xs sm:text-sm text-gray-700 pt-3 border-t border-gray-100">
                  <span className="flex items-center">
                    <i className="ri-ruler-line mr-1.5"></i>
                    {project.surface}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal détail projet */}
      {selectedProject && (
        <div 
          className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedProject(null)}
        >
          <div 
            className="bg-white rounded-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="sticky top-0 bg-white border-b border-gray-200 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between z-10">
              <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 pr-4">{selectedProject.title}</h2>
              <button
                onClick={() => setSelectedProject(null)}
                className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer flex-shrink-0"
              >
                <i className="ri-close-line text-xl sm:text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="p-4 sm:p-6">
              {/* Comparaison Avant/Après */}
              <div className="mb-6 sm:mb-8">
                <div className="flex items-center justify-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                  <button
                    onClick={() => setShowBefore(true)}
                    className={`px-4 sm:px-6 py-2 sm:py-2.5 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base ${
                      showBefore ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'
                    }`}
                  >
                    Avant
                  </button>
                  <button
                    onClick={() => setShowBefore(false)}
                    className={`px-4 sm:px-6 py-2 sm:py-2.5 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base ${
                      !showBefore ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'
                    }`}
                  >
                    Après
                  </button>
                </div>
                <div className="relative h-64 sm:h-80 md:h-96 rounded-xl overflow-hidden">
                  <img
                    src={showBefore ? selectedProject.imageBefore : selectedProject.imageAfter}
                    alt={showBefore ? 'Avant' : 'Après'}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* Informations */}
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 mb-4 sm:mb-6">
                <div className="bg-blue-50 rounded-lg p-3 sm:p-4">
                  <div className="text-xs sm:text-sm text-gray-600 mb-1">Catégorie</div>
                  <div className="font-semibold text-gray-900 text-sm sm:text-base">{selectedProject.category}</div>
                </div>
                <div className="bg-blue-50 rounded-lg p-3 sm:p-4">
                  <div className="text-xs sm:text-sm text-gray-600 mb-1">Localisation</div>
                  <div className="font-semibold text-gray-900 text-sm sm:text-base">{selectedProject.location}</div>
                </div>
                <div className="bg-blue-50 rounded-lg p-3 sm:p-4">
                  <div className="text-xs sm:text-sm text-gray-600 mb-1">Surface</div>
                  <div className="font-semibold text-gray-900 text-sm sm:text-base">{selectedProject.surface}</div>
                </div>
              </div>

              {/* Description */}
              <div className="mb-4 sm:mb-6">
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3">Description du projet</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">{selectedProject.description}</p>
              </div>

              {/* Caractéristiques */}
              <div>
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3">Caractéristiques principales</h3>
                <div className="flex flex-wrap gap-2">
                  {selectedProject.features.map((feature, index) => (
                    <span
                      key={index}
                      className="bg-blue-100 text-blue-700 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProjectsGrid;
